const recepciones = state => state.recepciones;
const contenedores = state => state.contenedores;
const rutas = state => state.rutas;

// New getters for invoice persistence
const selectedInvoice = state => state.selectedInvoice;
const receiptType = state => state.receiptType;

export default {
  recepciones,
  contenedores,
  rutas,
  selectedInvoice,
  receiptType
};